module.exports = __webpack_public_path__ + "img/home-banner@0.75x.fd9fb821.jpg";